import { Col, Row, Table, Progress } from "reactstrap";
import { useContext, useEffect, useState } from "react";
import { getDeviceConfig, getDeviceId, getEventInfo } from "../../api/api";
import Spinner from "../../commons/Spinner";
import { format } from "date-fns";
import { SchoolContext } from "../../context/SchoolContext";
import { useHistory } from "react-router-dom";
import { idExists } from "../../utils/NumberUtils";
import DatePicker from "react-datepicker"
import { ja } from "date-fns/locale";

const Errorpage = () => {

    const { schoolList, setSchool } = useContext(SchoolContext)
    const [pcsData, setpcsData] = useState([]);
    const [event, setEvent] = useState([]);

    const [date, setDate] = useState(true);
    const [eventInfo, setEventInfo] = useState(true);
    const [sortbyname, setSortbyname] = useState(true);

    const HideDateSelect = () => { setDate(!date); };
    const HideEvent = () => setEventInfo(!eventInfo);
    const HideNameSorting = () => setSortbyname(!sortbyname);

    // const [currentDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false)
    const authToken = localStorage.getItem('accessToken');
    const [deviceId, setDeviceId] = useState(null);
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [markerId, setMarkerId] = useState("");
    const [progressValue, setProgressValue] = useState(0)
    const [filterParams, setFilterParams] = useState({
        eventType: [],
        modelName: [],
        fromDate: "",
        toDate: "",
        scrolled: false
    });
    const [visible, setVisible] = useState(true);
    const [hasScrollBar, setHasScrollBar] = useState(false);
    const table = document.getElementById("eventData");
    const history = useHistory();
    const pathname = history["location"].pathname
    const school_id = Number(pathname.split('/').pop());
    // const activationDate = schoolList.length > 0 && idExists(schoolList, school_id) && schoolList[school_id - 1].operation_start_date;    
    const [openCalendar, setOpenCalendar] = useState(false);
    const [Calendar, setCalendar] = useState(false);

    const handleFilterSelect = (checked, name, value) => {
        setMarkerId("");
        const target = document.getElementById('eventData');
        if (target && target.scrollTop > 0) {
            target.scrollTop = 0;
        }
        // setEventType(eventType)
        let tempEventType = filterParams[`${name}`]
        if (checked && !filterParams[`${name}`].includes(value)) {
            tempEventType = [...filterParams[`${name}`], value]
            setFilterParams({
                ...filterParams,
                [name]: tempEventType,
                scrolled: false
            })
        } else if (!checked && filterParams[`${name}`].includes(value)) {
            tempEventType = filterParams[`${name}`].filter(v => v !== value)
            setFilterParams({
                ...filterParams,
                [name]: tempEventType,
                scrolled: false
            })
        }
    }

    useEffect(() => {
        const { eventType, fromDate, toDate, modelName, scrolled } = filterParams
        const controller = new AbortController();
        const signal = controller.signal;
        let i = 0
        setTableLoading(true);
        setProgressValue(i);
        setInterval(() => {
            if (i < 101) {

                setProgressValue(i++);
            }
        }, 25)
        if (deviceId !== null) {
            getEventInfo(authToken, deviceId, fromDate !== "" ? format(fromDate, "yyyy-MM-dd HH:mm:ss") : "", toDate !== "" ? format(toDate, "yyyy-MM-dd HH:mm:ss") : "", markerId, modelName, eventType, signal).then(response => {
                if (markerId && scrolled) {
                    if (response && Object.keys(response).length !== 0) {
                        setpcsData([...pcsData, ...response]);
                        setTableLoading(false)
                        setProgressValue(100);
                    }
                    else {
                        if (Array.isArray(response) && response.length !== 0) {
                            setpcsData(response);
                            setMarkerId('');
                        }
                        setTableLoading(false)
                        setProgressValue(100);
                    }
                } else {
                    if (response && response !== undefined) {
                        setpcsData(response);
                        setMarkerId('');
                        setTableLoading(false);
                        setProgressValue(100);
                    }
                }
                if (table && response) {
                    if (table.scrollHeight > table.clientHeight) {
                        setHasScrollBar(true);
                    }
                    else {
                        setHasScrollBar(false);
                        if (response && Object.keys(response).length === 0) {
                            // setHasScrollBar(false);
                            setHasScrollBar(true);
                        }
                    }
                }
            }).catch(error => {
                setTableLoading(false)
            })

            return () => {
                controller.abort();
            };
        } else {
            //added to avoid infinite progress value when deviceid is not present
            setTableLoading(false);
            setProgressValue(0)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterParams, deviceId, markerId])



    useEffect(() => {
        if (deviceId !== null) {
            setLoading(true);
            const controller = new AbortController();
            const signal = controller.signal;

            const fetchEvent = async (signal) => {
                const res = await getEventInfo(authToken, deviceId, "", "", "", [], [], signal);
                setpcsData(res);
                setLoading(false);
            }
            fetchEvent(signal);

            return () => {
                controller.abort();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deviceId])

    useEffect(() => {
        setLoading(true)
        const Value = JSON.parse(localStorage.getItem('schools'));
        const schoolObj = { id: school_id };
        if (Value && Value !== null && Value.some(obj => obj.id === schoolObj.id)) {
            setDeviceId(Value.find(obj => obj.id === schoolObj.id).device_id);
            setSchool(Number(school_id));
            setLoading(false);
        } else {
            if (schoolList.length > 0) {
                if (idExists(schoolList, school_id)) {
                    setSchool(school_id);
                    const Id = async () => {
                        const res = await getDeviceId(schoolList[school_id - 1].place_id, authToken);
                        if (res && res.sems_device_id) {
                            const value = localStorage.getItem('schools');
                            const schools = value ? JSON.parse(value) : [];
                            const schoolObj = { id: school_id, device_id: res.sems_device_id };
                            schools.push(schoolObj);
                            localStorage.setItem('schools', JSON.stringify(schools));
                            setDeviceId(res.sems_device_id)
                        }
                        setLoading(false);
                    }
                    Id();
                } else {
                    history.push('/home')
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, schoolList, school_id])

    useEffect(() => {
        if (deviceId !== null) {
            setLoading(true);
            const controller = new AbortController();
            const signal = controller.signal;
            const deviceData = async (signal) => {
                const res = await getDeviceConfig(authToken, deviceId, { configType: 'device_models' }, signal);
                setEvent(res);
                setLoading(false);
            }
            deviceData(signal);
            return () => {
                controller.abort();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deviceId])

    useEffect(() => {
        if (table) {
            if (table.scrollHeight > table.clientHeight) {
                setHasScrollBar(true);
            }
            else {
                if (!hasScrollBar && pcsData && pcsData.length > 0) {
                    setHasScrollBar(false);
                    const { eventType, fromDate, toDate, modelName } = filterParams
                    const marker = pcsData[Object.keys(pcsData)[Object.keys(pcsData).length - 1]].marker_id;
                    let i = 0
                    setTableLoading(true);
                    setProgressValue(i);
                    setInterval(() => {
                        if (i < 101) {

                            setProgressValue(i++);
                        }
                    }, 10)
                    getEventInfo(authToken, deviceId, fromDate !== "" ? format(fromDate, "yyyy-MM-dd HH:mm:ss") : "", toDate !== "" ? format(toDate, "yyyy-MM-dd HH:mm:ss") : "", marker, modelName, eventType).then(response => {
                        // setTimeout(() => {
                        if (response && Object.keys(response).length !== 0) {
                            setpcsData([...pcsData, ...response])
                        }
                        setTableLoading(false)
                        setProgressValue(100);
                        if (table) {
                            if (table.scrollHeight > table.clientHeight) {
                                setHasScrollBar(true);
                            }
                            else {
                                setHasScrollBar(false);
                                if (response && Object.keys(response).length === 0) {
                                    setHasScrollBar(true);
                                }
                            }
                        }
                        // }, 2000)
                    }).catch(error => {
                        setTableLoading(false)
                    })
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deviceId, filterParams, hasScrollBar, pcsData, table])

    const handleDateChangeFrom = (e) => {
        let changedDate;
        if (e === null || e === '') {
            changedDate = ''
        } else {
            changedDate = (new Date(e));
            changedDate.setHours(0);
            changedDate.setMinutes(0);
            changedDate.setSeconds(0);
        }
        setMarkerId("")
        setDateFrom(changedDate);
        setFilterParams({
            ...filterParams,
            fromDate: changedDate,
            scrolled: false
        })

    };

    const handleDateChangeTo = (e) => {
        let changedDate;
        if (e === null || e === '') {
            changedDate = ''
        } else {
            changedDate = (new Date(e));
            changedDate.setHours(0);
            changedDate.setMinutes(0);
            changedDate.setSeconds(0);
        }
        setMarkerId("")
        setDateTo(changedDate);
        setFilterParams({
            ...filterParams,
            toDate: changedDate,
            scrolled: false
        })

    };

    const handleScroll = () => {
        if (!tableLoading) {
            const target = document.getElementById('eventData');
            const scrollHeight = target.scrollHeight;
            const scrollTop = target.scrollTop;
            const clientHeight = target.clientHeight;
            if (Math.abs(scrollHeight - clientHeight - scrollTop) <= 1 && pcsData.length > 0) {
                const marker = pcsData[Object.keys(pcsData)[Object.keys(pcsData).length - 1]];
                setFilterParams({
                    ...filterParams,
                    scrolled: true
                });
                setMarkerId(marker.marker_id);
            }
        }
    }

    return (
        <> {loading ? <Spinner /> : <section>
            <Col className="d-flex flex-row deviceSection">
                <Col className={`${visible ? "col1" : "col1hide"} pb-3 side-menubar`}>
                    <Row className="justify-content-between h-100 content-mobile-error">
                        {visible ? <Col>
                            <Row>
                                <span className="text_graph mx-auto">ソート</span>
                            </Row>
                            <Row className="mt-4 d-flex flex-column">
                                <Col>
                                    <Row className="bg_errorP headingSpace" onClick={HideDateSelect}>
                                        {date ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-chevron-down ml-2 my-auto" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                        </svg> :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-chevron-up ml-2 my-auto" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
                                            </svg>}
                                        <span className="text__large ml-3 heading__text">期間</span>
                                    </Row>

                                    <Row className="d-flex flex-column mt-3">
                                        {date ? <><div className="errorDate">
                                            <DatePicker className="remote_time remote__input remote_datepicker"
                                                type='date'
                                                portalId="root-portal"
                                                placeholderText="開始日"
                                                selected={Date.parse(dateFrom)}
                                                locale={ja}
                                                onChange={handleDateChangeFrom}
                                                maxDate={new Date()}
                                                // minDate={new Date(activationDate)}
                                                showIcon
                                                dateFormat='yyyy-MM-dd'
                                                icon={
                                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }} onClick={() => setOpenCalendar(!openCalendar)}>
                                                        <rect x="3" y="6" width="18" height="15" rx="2" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" />
                                                        <path d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z" fill="#233C6B" fill-opacity="0.73" />
                                                        <path d="M7 3L7 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                        <path d="M17 3L17 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                        <rect x="7" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                        <rect x="7" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                        <rect x="13" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                        <rect x="13" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                    </svg>
                                                }
                                                open={openCalendar}
                                                onInputClick={() => setOpenCalendar(!openCalendar)}
                                                onClickOutside={() => setOpenCalendar(false)}
                                            />
                                        </div>
                                            <div className="mt-3 errorDate">
                                                <DatePicker className="remote_time remote__input remote_datepicker"
                                                    type='date'
                                                    portalId="root-portal"
                                                    placeholderText="終了日"
                                                    selected={Date.parse(dateTo)}
                                                    locale={ja}
                                                    onChange={handleDateChangeTo}
                                                    maxDate={new Date()}
                                                    // minDate={new Date(activationDate)}
                                                    showIcon
                                                    dateFormat='yyyy-MM-dd'
                                                    icon={
                                                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }} onClick={() => setCalendar(!Calendar)}>
                                                            <rect x="3" y="6" width="18" height="15" rx="2" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" />
                                                            <path d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z" fill="#233C6B" fill-opacity="0.73" />
                                                            <path d="M7 3L7 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                            <path d="M17 3L17 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                            <rect x="7" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                            <rect x="7" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                            <rect x="13" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                            <rect x="13" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                        </svg>
                                                    }
                                                    open={Calendar}
                                                    onInputClick={() => setCalendar(!Calendar)}
                                                    onClickOutside={() => setCalendar(false)}
                                                />
                                            </div></> : ''}
                                    </Row>
                                </Col>

                                <Col className="mt-4">
                                    <Row className="bg_errorP headingSpace" onClick={HideEvent}>
                                        {eventInfo ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-chevron-down ml-2 my-auto" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                        </svg> :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-chevron-up ml-2 my-auto" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
                                            </svg>}
                                        <span className="text__large ml-3 heading__text">イベントの種類</span>
                                    </Row>
                                    {eventInfo ?
                                        <Row className="px-2 mt-3">
                                            <div className="col iconErrorDiv">
                                                <Row className="d-flex justify-content-between align-items-center">
                                                    <input type="checkbox" id="null" className="checkboxScale" checked={filterParams.eventType.includes("G")} value={"G"} onChange={(e) => {
                                                        handleFilterSelect(e.target.checked, "eventType", "G")
                                                    }} />
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="26" fill="green" className="bi bi-check-circle" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                                                    </svg>
                                                </Row>
                                                <Row className="mt-3 d-flex justify-content-between align-items-center">
                                                    <input type="checkbox" id="E" className="checkboxScale" checked={filterParams.eventType.includes("E")} value={"E"} onChange={(e) => {
                                                        handleFilterSelect(e.target.checked, "eventType", "E")
                                                    }} />
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" fill="red" className="bi bi-x-circle" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                    </svg>
                                                </Row>
                                                <Row className="mt-3 d-flex justify-content-between align-items-center ">
                                                    <input type="checkbox" id="W" className="checkboxScale" checked={filterParams.eventType.includes("W")} value={"W"} onChange={(e) => {
                                                        handleFilterSelect(e.target.checked, "eventType", "W")

                                                    }} />
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" fill="#ffba00" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                                        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                                                        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                                                    </svg>
                                                </Row>
                                                <Row className="mt-3 d-flex justify-content-between align-items-center">
                                                    <input type="checkbox" id="C" className="checkboxScale" checked={filterParams.eventType.includes("C")} value={"C"} onChange={(e) => {
                                                        handleFilterSelect(e.target.checked, "eventType", "C")

                                                    }} />
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" fill="currentColor" className="bi bi-exclamation-circle" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                                                    </svg>
                                                </Row>
                                            </div>
                                            <div className="col pl-4 textErrorDiv">
                                                <Row className="">
                                                    <span className="text_md">情報 </span>
                                                </Row>
                                                <Row className="mt-3 ">
                                                    <span className="text_md">エラー </span>
                                                </Row>
                                                <Row className="mt-3 ">
                                                    <span className="text_md">警告 </span>
                                                </Row>
                                                <Row className="mt-3 ">
                                                    <span className="text_md">通信エラー </span>
                                                </Row>
                                            </div>
                                        </Row> : ""}
                                </Col>

                                <Col className="mt-4">
                                    <Row className="bg_errorP headingSpace" onClick={HideNameSorting}>
                                        {sortbyname ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-chevron-down ml-2 my-auto" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                        </svg> :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-chevron-up ml-2 my-auto" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
                                            </svg>}
                                        <span className="text__large ml-3 heading__text">製品名</span>
                                    </Row>
                                    {sortbyname ? <Row className="px-2 mt-2">
                                        <Col>
                                            {event ? event.map((value, index) => {
                                                return (
                                                    <>
                                                        <Row className="productName align-items-center">
                                                            <input type="checkbox" id="Wait" className="checkboxScale mt-3" checked={filterParams.modelName.includes(`${value}`)} value={value} onClick={(e) => {
                                                                //  setModel(!model) 
                                                                handleFilterSelect(e.target.checked, "modelName", `${value}`)
                                                            }} />
                                                            <span className="text_md padding3 pt-2">{value}</span>
                                                        </Row>
                                                    </>
                                                )
                                            }) : ""}
                                        </Col>
                                    </Row> : ""}
                                </Col>
                            </Row>
                        </Col> : ''}
                        <div className="collapse_bar" onClick={() => { setVisible(!visible) }}>
                            {/* <div className="collaps_btn">
                                {visible ? <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" fill="#fff" className="bi bi-chevron-left" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                </svg> :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" fill="#fff" className="bi bi-chevron-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                                    </svg>}
                            </div> */}
                        </div>
                    </Row>
                </Col>
                <Col lg={`${visible ? 10 : ''}`} sm={`${visible ? 12 : ''}`} xl={`${visible ? 10 : ''}`} md={`${visible ? 10 : ''}`} className="col-12">
                    <Row>
                        <span className="text_graph mx-auto">イベント履歴</span>
                    </Row>
                    <Row className="mt-4 table__container">
                        <Col className="table__container">
                            {tableLoading &&
                                <Progress animated={true} color="info" value={progressValue} style={{
                                    height: "5px"
                                }} />

                            }
                            <Table className="event_data" id="eventData" onScroll={handleScroll}>
                                <thead>
                                    <th>デバイス名</th>
                                    <th>製品名</th>
                                    <th>イベントの種類</th>
                                    <th>イベントID</th>
                                    <th>イベント</th>
                                    <th>発生時刻</th>
                                    <th>解除時刻</th>
                                </thead>
                                <tbody>
                                    {pcsData && Object.keys(pcsData).length > 0 ? pcsData.map((value, index) => {
                                        return (

                                            <tr key={index}>
                                                <td>{value.device_id}</td>
                                                <td>{value.device_model_no}</td>
                                                <td>{
                                                    value.event_type === null || value.event_type === "G" ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green" className="bi bi-check-circle" viewBox="0 0 16 16">
                                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                                                        </svg>
                                                        : value.event_type === "E" ?
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-x-circle" viewBox="0 0 16 16">
                                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                            </svg>
                                                            : value.event_type === "C" ?
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle" viewBox="0 0 16 16">
                                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                                    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                                                                </svg>
                                                                : value.event_type === "W" ?
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffba00" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                                                        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                                                                        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                                                                    </svg> : ""
                                                }
                                                </td>
                                                <td>{value.event_code}</td>
                                                <td>{value.hasOwnProperty('message') ? value.message && value.message !== null ? value.message : "---" : "---"}</td>
                                                <td>{value.hasOwnProperty('start_time') ? value.start_time && value.start_time !== null ? value.start_time : "---" : "---"}</td>
                                                <td>{value.hasOwnProperty('end_time') ? value.end_time && value.end_time !== null ? value.end_time : "---" : "---"}</td>
                                            </tr>
                                        )
                                    }) : ""}

                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Col>
            </Col>
        </section >} </>
    );

}

export default Errorpage;